import React, { useMemo, useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

/** Helpers */
const slugify = (str = "") =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");

const dayOptions = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [title, setTitle] = useState("");
  const [venue, setVenue] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const [fee, setFee] = useState(0);
  const [vip, setVip] = useState(0);
  const [vvip, setVvip] = useState(0);

  const [email, setEmail] = useState("");
  const [payLink, setPayLink] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");

  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState("");

  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [nightlifeStatus, setNightlifeStatus] = useState(1);
  const [expo, setExpo] = useState(0);
  const [pricing, setPricing] = useState([]);

  const [description, setDescription] = useState("");
  const [repeatEvery, setRepeatEvery] = useState(""); // pipe-separated string
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  const nightlifeRoutes = "/data/nightlife";

  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  const clearForm = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(defaultImage);
    setThumbnailId("img_cdn_id");
    setTitle("");
    setVenue("");
    setStartDate("");
    setEndDate("");
    setStartTime("");
    setEndTime("");
    setFee(0);
    setVip(0);
    setVvip(0);
    setExpo(0);
    setEmail("");
    setPayLink(null);
    setPhoneNumber("");
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress("");
    setFeatured("no");
    setPromoted("no");
    setDescription("");
    setRepeatEvery("");
    setPricing([]);
  };

  const toggleRepeat = (val) => {
    const parts = repeatEvery ? repeatEvery.split("|").filter(Boolean) : [];
    if (parts.includes(val)) {
      const next = parts.filter((d) => d !== val).join("|");
      setRepeatEvery(next);
    } else {
      const next = [...parts, val].join("|");
      setRepeatEvery(next);
    }
  };

  const isDaySelected = (val) =>
    (repeatEvery || "").toString().split("|").includes(val);

  const canSubmit = useMemo(() => {
    if (!title || !thumbnail || !thumbnailId) return false;
    if (startDate && endDate) {
      const sd = new Date(`${startDate}T${startTime || "00:00"}`);
      const ed = new Date(`${endDate}T${endTime || "23:59"}`);
      if (sd > ed) return false;
    }
    return true;
  }, [title, thumbnail, thumbnailId, startDate, endDate, startTime, endTime]);

  const addOneNightlifeHandler = async (e) => {
    e.preventDefault();

    if (!thumbnail || !thumbnailId) {
      responses(true, "Profile image is required.");
      return;
    }
    if (!title) {
      responses(true, "Title is required.");
      return;
    }
    if (startDate && endDate) {
      const sd = new Date(`${startDate}T${startTime || "00:00"}`);
      const ed = new Date(`${endDate}T${endTime || "23:59"}`);
      if (sd > ed) {
        responses(true, "Start date/time must be before end date/time.");
        return;
      }
    }

    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id,
      first_level_id: first_level_id || 0,
      second_level_id: second_level_id || 0,
      third_level_id: third_level_id || 0,
      fourth_level_id: fourth_level_id || 0,
      title,
      slug: title ? slugify(title) : null,
      description,
      venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      fee,
      vip,
      vvip,
      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",
      phone_number: phoneNumber || null,
      email_address: email || null,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: `${tags || ""}${tags ? ", " : ""}${hashtags || ""}`,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress || null,
      country_short: "none",
      status: nightlifeStatus,
      featured,
      promoted,
      repeat_every: repeatEvery,
      expo,
      pricing,
    };

    const { status, message } = await createOneContent({
      data,
      content: _TYPES_.NIGHTLIFE,
    });

    if (status === 200 || status === 201) {
      clearForm();
      responses(false, message || "Nightlife added.");
    } else {
      responses(true, message || "Failed to add nightlife.");
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>
        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: nightlifeRoutes }} />
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <div className="mb-4">
          <DashboardIntro
            props={{ intro: `Add Nightlife`, name: entry_label }}
          />
        </div>

        {/* Alerts */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        {/* Cover Upload */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-1/2">
              <p className="text-xs font-semibold text-slate-600 mb-2">
                Profile Image
              </p>
              <ImageKitUpload
                thumbnail={thumbnail}
                thumbnailId={thumbnailId}
                setThumbnail={setThumbnail}
                setThumbnailId={setThumbnailId}
                folder={image_kit_folder(country_name, FOLDERS.NIGHTLIFE)}
              />
              <p className="text-xs text-slate-500 mt-2">
                Recommended: square image, clear logo or venue cover.
              </p>
            </div>
            <div className="w-full md:w-1/2 space-y-3">
              <Title props={{ title: "Nightlife Details" }} />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <InputField
                  props={{
                    id: "title",
                    title: "Title",
                    type: "text",
                    required: true,
                    value: title,
                    placeholder: "e.g., Full Moon Party",
                    onChange: (e) => {
                      setTitle(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "venue",
                    title: "Venue",
                    type: "text",
                    value: venue,
                    placeholder: "e.g., Ocean Club",
                    onChange: (e) => {
                      setVenue(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "formatted_address",
                    title: "Formatted Address",
                    type: "address",
                    value: formattedAddress,
                    placeholder: "Street, City, Country",
                    onChange: (e) => {
                      setFormattedAddress(e.target.value);
                      setError(false);
                      setSuccess(false);
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Date & Time */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "Date & Time" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <InputField
              props={{
                id: "start_date",
                title: "Start Date",
                type: "date",
                value: startDate,
                onChange: (e) => {
                  setStartDate(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <InputField
              props={{
                id: "end_date",
                title: "End Date",
                type: "date",
                value: endDate,
                onChange: (e) => {
                  setEndDate(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <InputField
              props={{
                id: "start_time",
                title: "Start Time",
                type: "time",
                value: startTime,
                onChange: (e) => {
                  setStartTime(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <InputField
              props={{
                id: "end_time",
                title: "End Time",
                type: "time",
                value: endTime,
                onChange: (e) => {
                  setEndTime(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
          </div>

          <div className="mt-5">
            <p className="text-sm font-medium text-slate-700">Repeat Every</p>
            <div className="flex flex-wrap gap-3 mt-2">
              {dayOptions.map((val) => {
                const active = isDaySelected(val);
                return (
                  <button
                    key={val}
                    type="button"
                    onClick={() => toggleRepeat(val)}
                    className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 border text-sm capitalize transition ${
                      active
                        ? "bg-blue-50 border-blue-200 text-blue-700"
                        : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
                    }`}
                  >
                    {active ? (
                      <MdCheckBox className="text-lg" />
                    ) : (
                      <MdCheckBoxOutlineBlank className="text-lg" />
                    )}
                    {val}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Pricing */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "Pricing" }} />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <InputField
              props={{
                id: "fee",
                title: "General Fee",
                type: "number",
                value: fee,
                min: 0,
                onChange: (e) => setFee(Number(e.target.value || 0)),
              }}
            />
            <InputField
              props={{
                id: "vip",
                title: "VIP",
                type: "number",
                value: vip,
                min: 0,
                onChange: (e) => setVip(Number(e.target.value || 0)),
              }}
            />
            <InputField
              props={{
                id: "vvip",
                title: "VVIP",
                type: "number",
                value: vvip,
                min: 0,
                onChange: (e) => setVvip(Number(e.target.value || 0)),
              }}
            />
          </div>
          <Pricing pricing={pricing} setPricing={setPricing} />
        </div>

        {/* Contact Info */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "Contact Info" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="flex items-center">
              <PhoneInput
                setPhone={setPhoneNumber}
                phone={phoneNumber}
                required={false}
              />
            </div>
            <InputField
              props={{
                id: "email",
                title: "Email Address",
                type: "email",
                value: email,
                onChange: (e) => setEmail(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "pay-link",
                title: "Pay Link (Optional)",
                type: "text",
                value: payLink ? payLink : null,
                onChange: (e) => {
                  setPayLink(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </div>

        {/* Social */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "Social Contact" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <InputField
              props={{
                id: "whatsapp",
                title: "Whatsapp",
                type: "text",
                value: whatsapp,
                onChange: (e) => setWhatsapp(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "facebook",
                title: "Facebook",
                type: "text",
                value: facebook,
                onChange: (e) => setFacebook(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "twitter",
                title: "Twitter",
                type: "text",
                value: twitter,
                onChange: (e) => setTwitter(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "instagram",
                title: "Instagram",
                type: "text",
                value: instagram,
                onChange: (e) => setInstagram(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "youtube",
                title: "YouTube",
                type: "text",
                value: youtube,
                onChange: (e) => setYoutube(e.target.value),
              }}
            />
          </div>
        </div>

        {/* Geo */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "Geo Position" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            <InputField
              props={{
                id: "google_map_code",
                title: "Google Map Code",
                type: "text",
                value: googleMapCode,
                onChange: (e) => setGoogleMapCode(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "latitude",
                title: "Latitude",
                type: "text",
                value: latitude,
                onChange: (e) => setLatitude(e.target.value),
              }}
            />
            <InputField
              props={{
                id: "longitude",
                title: "Longitude",
                type: "text",
                value: longitude,
                onChange: (e) => setLongitude(e.target.value),
              }}
            />
          </div>
        </div>

        {/* Settings */}
        <div className={`${card} ${sectionPad} mb-4`}>
          <Title props={{ title: "More Settings" }} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            <Select
              props={{
                id: "nightlife_status",
                title: "Status",
                option: ["visible", "invisible"],
                onChange: (e) => {
                  setNightlifeStatus(e.target.selectedIndex === 0 ? 1 : 0);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <Select
              props={{
                id: "featured",
                title: "Featured",
                option: ["no", "yes"],
                onChange: (e) => {
                  setFeatured(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <Select
              props={{
                id: "promoted",
                title: "Promoted",
                option: ["no", "yes"],
                onChange: (e) => {
                  setPromoted(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
            <Select
              props={{
                id: "gallery",
                title: "Show in Gallery",
                option: ["no", "yes"],
                onChange: (e) => {
                  setExpo(e.target.value === "no" ? 0 : 1);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
          </div>
        </div>

        {/* Description & Tags */}
        <div className={`${card} ${sectionPad} mb-6`}>
          <div className="flex items-center justify-between mb-3">
            <Title props={{ title: "Description" }} />
            <MyButton
              onClick={() => setShowDescriptionModal(true)}
              className="bg-blue-700 hover:bg-blue-600 text-white px-3 py-2 rounded-lg"
            >
              Generate Description
            </MyButton>
          </div>

          <TextArea
            props={{
              id: "description",
              title: "Description",
              type: "text",
              value: description,
              onChange: (e) => {
                setDescription(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <InputField
              props={{
                id: "hashtag",
                title: "Tags (comma separated)",
                type: "text",
                value: hashtags,
                placeholder: "music, dance, rooftop",
                onChange: (e) => {
                  setHashtags(e.target.value);
                  setError(false);
                  setSuccess(false);
                },
              }}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center justify-end">
          <MyActionButton
            loading={loading}
            title="Add Nightlife"
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
            // Guard in handler; button UI remains same
          />
        </div>

        {/* Hidden form submit to respect parent <form> signature if needed */}
        <form onSubmit={addOneNightlifeHandler}>
          {/* Using a hidden submit so keyboard Enter works anywhere */}
          <button
            type="submit"
            className="hidden"
            disabled={!canSubmit || loading}
          />
        </form>
      </div>
    </div>
  );
};

export default Add;
